<template>
  <div>
    <nav class="nav flex-column nav-pills nav-editor link-danovnik">
      <nav-link
        class="upCase"
        :to="{ name: 'danovnik' }">
        {{ $t('message.lblDan') }}
      </nav-link>
    </nav>

    <collapse
      collapse-id="x1"
      sub-active-check="/udajeDanovnikovi/:userId"
      :title="$t('message.zDBonus')">
      <nav-link
        class="upCase"
        :to="{ name: 'zaplatenePrispevky' }">{{ $t('message.menuDan') }}</nav-link>
      <nav-link
        class="upCase"
        :to="{ name: 'manzel' }">{{ $t('message.menuManzel') }}</nav-link>
      <nav-link
        class="upCase"
        :to="{ name: 'vyzDeti' }">{{ $t('message.menuDeti') }}</nav-link>
    </collapse>

    <nav class="nav flex-column nav-pills nav-editor">
      <nav-link
        class="upCase"
        :to="{ name: 'poukazanie'}">
        {{ $t('message.menuPoukaz') }}
      </nav-link>
      <nav-link
        class="upCase"
        :to="{ name: 'osobitneZaznamy', params: { userId: $route.params.userId}}">
        {{ $t('message.menuOsobitne') }}
      </nav-link>
      <nav-link
        class="upCase"
        :to="{ name: 'zakonnyZastupca'}">
        {{ $t('message.menuZastupca') }}
      </nav-link>
    </nav>
    <hr>
    <poucenie />
  </div>
</template>

<script>
import Collapse from './Collapse.vue';
import navLink from './navLink.vue';
import poucenie from './poucenie.vue';

export default {
  components: {
    Collapse,
    navLink,
    poucenie
  }
};
</script>

<style>
.link-danovnik {
  margin-top: 8px;
}
</style>
